export * from './authServiceContract';
export * from './fetchServiceContract';
export * from './eventsServiceContract';
export * from './windowsServiceContract';
export * from './stringsServiceContract';
export * from './settingsChangeServiceContract';
export * from './settingsChangeServiceData/settingsChangeServiceData';
export * from './settingsChangeServiceData';
export * from './configServiceContract';
export * from './auditServiceContract';

const CONTRACTS = {
    AuthService: Symbol.for('AuthService'),
    FetchService: Symbol.for('FetchService'),
    EventsService: Symbol.for('EventsService'),
    WindowsService: Symbol.for('WindowsService'),
    StringsService: Symbol.for('StringsService'),
    SettingsChangeServiceFactory: Symbol.for('SettingsChangeServiceFactory'),
    SettingsChangeService: Symbol.for('SettingsChangeService'),
    ConfigService: Symbol.for('ConfigService'),
    AuditService: Symbol.for('AuditService')
};

export { CONTRACTS };
